import { useMutation, useQuery } from "@tanstack/react-query";
import { LazyParams } from "../services/lazyParams";
import { MobiTheraService } from "../services/mobiTheraService";

export const useConsultantLogin = () =>
  useMutation({
    mutationFn: (requestBody: any) => new MobiTheraService().consultantLogin(requestBody),
  })

export const useTokenCheckWithRefreshToken = () =>
  useQuery({
    queryKey: ['tokenCheckWithRefreshToken'],
    queryFn: () => new MobiTheraService().tokenCheckWithRefreshToken(),
  })

export const useConsultantRegister = () =>
  useMutation({
    mutationFn: (requestBody: any) => new MobiTheraService().consultantRegister(requestBody),
  })

export const useConsultantSignout = () =>
  useMutation({
    mutationFn: (refreshToken: string) => new MobiTheraService().consultantSignout(refreshToken),
  })

export const useConsultantGetCalismaSonuc = () =>
  useMutation({
    mutationFn: (requestBody: any) => new MobiTheraService().consultantGetCalismaSonuc(requestBody),
  })

export const useConsultantGetTahsilSonuc = () =>
  useMutation({
    mutationFn: (requestBody: any) => new MobiTheraService().consultantGetTahsilSonuc(requestBody),
  })

export const useConsultantGetUshHizmetiSonuc = () =>
  useMutation({
    mutationFn: (requestBody: any) => new MobiTheraService().consultantGetUshHizmetiSonuc(requestBody),
  })

export const useGetPatientNewListQuery = () =>
  useMutation({
    mutationFn: (lazyParamsForPatientNewList: any) => new MobiTheraService().getPatientNewList(lazyParamsForPatientNewList),
  });

export const useGetPatientListQuery = () =>
  useMutation({
    mutationFn: (lazyParamsForPatientList: any) => new MobiTheraService().getPatientList(lazyParamsForPatientList),
  });


export const useGetPatientMutation = () =>
  useMutation({
    mutationFn: (patientId: any) => new MobiTheraService().getPatien(patientId),
  });

export const useUpdatePatientMutation = () =>
  useMutation({
    mutationFn: (patient: any) => new MobiTheraService().updatePatient(patient),
  });

export const useAddPatient: any = () =>
  useMutation({
    mutationFn: (patient: any) => new MobiTheraService().addPatientToList(patient),
  });

export const useDeletePatient: any = () =>
  useMutation({
    mutationFn: (patient: any) => new MobiTheraService().deleteNewPatient(patient),
  });

export const useGetOnoingPlanListForTodayMutation = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getOngoingPlanListForToday(),
  });

export const useGetGeneralOnoingPlanListMutation = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getGeneralOngoingPlanList(),
  });

export const useGetStatusCountByConsultant = () =>
  useQuery({
    queryKey: ['statusCountByConsultant'],
    queryFn: () => new MobiTheraService().getStatusCountByConsultant(),
  });

export const useGetMonthlyStatus = () =>
  useQuery({
    queryKey: ['monthlyStatus'],
    queryFn: () => new MobiTheraService().getMonthlyStatus(),
  })

export const useGetCompletedPlanCounter = () =>
  useQuery({
    queryKey: ['completedPlanCounter'],
    queryFn: () => new MobiTheraService().getCompletedPlanCounter(),
  });

export const useAddPlan = () =>
  useMutation({
    mutationFn: (plan: any) => new MobiTheraService().addPlan(plan),
  });

export const useGetPlanListByPatient: any = () =>
  useMutation({
    mutationFn: (patientAndPlanInfo: any) => new MobiTheraService().getPlanListById(patientAndPlanInfo),
  });

export const useDeleteFuturePlan = () =>
  useMutation({
    mutationFn: (planId: any) => new MobiTheraService().deleteFuturePlan(planId),
  });

export const useGetMyPanels = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getMyPanels(),
  });

export const useGetSystemProcedures = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getSystemProcedures(),
  })

export const useSaveMyPanel = () =>
  useMutation({
    mutationFn: (myPanel: any) => new MobiTheraService().saveMyPanel(myPanel),
  });

export const useDeleteMyPanel = () =>
  useMutation({
    mutationFn: (panelId: any) => new MobiTheraService().deleteMyPanel(panelId),
  });

export const useUpdateMyPanel = () =>
  useMutation({
    mutationFn: (panel: any) => new MobiTheraService().updateMyPanel(panel),
  })

export const useUpdateAppointmentStatus = () =>
  useMutation({
    mutationFn: (appointment: any) => new MobiTheraService().updateAppointmentStatus(appointment),
  });

export const useGetAppointmentListQuery = () =>
  useMutation({
    mutationFn: (lazyParamsForAppointments: any) => new MobiTheraService().getAppointmentList(lazyParamsForAppointments),
  });

export const useGetExercisesListQuery = (lazyParamsForExercises: LazyParams) => {
  return useQuery({
    queryKey: ['exercisesList', lazyParamsForExercises],
    queryFn: () => new MobiTheraService().getExercisesList(lazyParamsForExercises),
  })
}

export const useGetExercisesListMutation = () =>
  useMutation({
    mutationFn: (lazyParamsForExercises: any) => new MobiTheraService().getExercisesList(lazyParamsForExercises),
  });

export const useGetAccessCode = () =>
  useMutation({
    mutationFn: (patientId: any) => new MobiTheraService().getAccessCode(patientId),
  })

export const useSubmitAccessCode = () =>
  useMutation({
    mutationFn: (patientObject: any) => new MobiTheraService().submitAccessCode(patientObject),
  })

export const useFavoriteExercise = () =>
  useMutation({
    mutationFn: (obj: any) => new MobiTheraService().favoriteExercise(obj),
  });


export const useGetVisitNotes = () =>
  useMutation({
    mutationFn: (patientId: any) => new MobiTheraService().getVisitNotes(patientId),
  })

export const useAddVisitNote = () =>
  useMutation({
    mutationFn: (visitNote: any) => new MobiTheraService().addVisitNote(visitNote),
  })

export const useUpdateVisitNote = () =>
  useMutation({
    mutationFn: (visitNote: any) => new MobiTheraService().updateVisitNote(visitNote),
  })

export const useAddDoctorNote = () =>
  useMutation({
    mutationFn: (credentials: any) => new MobiTheraService().addDoctorNote(credentials),
  });

export const useGetDoctorNotes = () =>
  useMutation({
    mutationFn: (patientId: any) => new MobiTheraService().getDoctorNotes(patientId),
  });

export const useUpdateDoctorNote = () =>
  useMutation({
    mutationFn: (credentials: any) => new MobiTheraService().updateDoctorNote(credentials),
  })

export const useDeleteDoctorNote = () =>
  useMutation({
    mutationFn: (credentials: any) => new MobiTheraService().deleteDoctorNote(credentials),
  })

export const useGetTreatmentCodeList = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getTreatmentCodeList(),
  });

export const useSendResetPasswordEmail = () =>
  useMutation({
    mutationFn: (email: any) => new MobiTheraService().sendResetPasswordEmail(email),
  });

export const useResetPassword = () =>
  useMutation({
    mutationFn: (credentials: any) => new MobiTheraService().resetPassword(credentials),
  });

export const useGetEmergencyStopDataList = () =>
  useMutation({
    mutationFn: () => new MobiTheraService().getEmergencyStopDataList(),
  });

export const useMarkEmergencyItemAsSeen = () =>
  useMutation({
    mutationFn: (id: any) => new MobiTheraService().markEmergencyItemAsSeen(id),
  });

export const useConsultantCreatePassword = () =>
  useMutation({
    mutationFn: (credentials: any) => new MobiTheraService().consultantPasswordCreation(credentials)
  })